package com.yogaaicoach.pages.dashboard

import com.yogaaicoach.common.ui.components.*
import Config
import com.yogaaicoach.pages.auth.TokenDataManager
import react.ChildrenBuilder
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.p
import web.cssom.ClassName

// Shared across every dashboard-mode page (OnboardingPage, ProgramDashboardPage, ...) — mirrors
// showFreeTrialBannerIfNeeded()/showTestButtonIfTestEnv(), which DashboardScreen.kt's various
// mode screens (OnboardingScreen, ProgramDashboardScreen, ...) all call the same way.

// DashboardScreen.kt's showTestButtonIfTestEnv() renders a real PrimaryButton (same as
// "Sign In"/"Create My Program"), not a plain text link.
internal fun ChildrenBuilder.TestButtonIfTestEnv(onNavigateToTest: () -> Unit) {
    if (!Config.ENABLE_TEST_MODE.toBoolean()) return
    button {
        className = ClassName("primary-button test-button")
        +"Test"
        onClick = { onNavigateToTest() }
    }
}

internal fun ChildrenBuilder.FreeTrialBannerIfNeeded() {
    val freeTrialDaysLeft = TokenDataManager.tokenData?.freeTrialDaysLeft ?: return
    val isSubscribed = TokenDataManager.tokenData?.isSubscribed ?: false
    val showBanner = !isSubscribed && freeTrialDaysLeft > 0 && freeTrialDaysLeft <= 7
    if (!showBanner) return

    val title = if (freeTrialDaysLeft == 1) "Trial ends today" else "Trial ending soon"
    val body = if (freeTrialDaysLeft == 1) {
        "You'll lose access unless you subscribe."
    } else {
        "$freeTrialDaysLeft days remaining. Subscribe to keep access."
    }

    div {
        className = ClassName("free-trial-banner")
        onClick = { console.log("Upgrade screen not implemented in this POC") }
        InfoIcon {}
        div {
            className = ClassName("free-trial-banner-text")
            p { className = ClassName("free-trial-banner-title"); +title }
            p { className = ClassName("free-trial-banner-body"); +body }
        }
        ChevronRightIcon {}
    }
}
